import React, { useState, useEffect } from 'react';
import CargomaticInput from 'components/v2/input';
import XIcon from 'components/v2/icons/XIcon';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { getCurrencySymbol } from 'components/modules/master/formatters';
export default function AddBaseCoseForm({ ledgerType, ledgers, onAddBaseCost, currency }) {
    const [hideBaseCostForm, setHideBaseCostForm] = useState(true);
    const [isAddingBaseCost, setIsAddingBaseCost] = useState(false);
    const [isSavingBaseCost, setIsSavingBaseCost] = useState(false);
    const [addBaseCostValue, setAddBaseCostValue] = useState('');
    const { t } = useTranslation();
    useEffect(() => {
        const baseCostCheck = ledgers.some((c) => c.category === 'base_cost');
        setHideBaseCostForm(baseCostCheck);
    }, [ledgers]);
    const addBaseCost = async () => {
        const baseCostLedger = {
            value: addBaseCostValue,
            type: ledgerType === 'receivables' ? 'shipper_cost' : 'carrier_cost',
        };
        setIsSavingBaseCost(true);
        const response = await onAddBaseCost(ledgerType, baseCostLedger);
        setIsSavingBaseCost(response);
    };
    if (hideBaseCostForm) {
        return null;
    }
    let buttonText;
    let onClick;
    if (isAddingBaseCost) {
        buttonText = titleize(t('SAVE'));
        onClick = () => addBaseCost();
    }
    else {
        buttonText = t('ADD_BASE_COST');
        onClick = () => setIsAddingBaseCost(true);
    }
    return ((React.createElement("div", { "data-testid": "div-23dd63ec", className: "flex items-center h-20 pl-4 bg-white border-t border-gray-200" },
        React.createElement("button", { "data-testid": "button-6a1407de", className: "button button-green w-32 h-10 mr-4 px-2 py-1", onClick: onClick, disabled: (isAddingBaseCost && addBaseCostValue <= 0) || isSavingBaseCost }, buttonText),
        isAddingBaseCost && (React.createElement(React.Fragment, null,
            getCurrencySymbol(currency),
            React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-d3967ed7", label: t('VALUE'), type: "number", className: "w-28 mb-6 ml-1", inputStyles: { textAlign: 'right' }, value: addBaseCostValue, onChange: setAddBaseCostValue }),
            React.createElement("button", { "data-testid": "button-b8bc4663", className: "ml-4", onClick: () => {
                    setIsAddingBaseCost(false);
                    setAddBaseCostValue('');
                } },
                React.createElement(XIcon, null)))))));
}
